import { generate } from 'random-words'

/**
 * A wlns user key is a set of random words joined by hyphens,
 * e.g. "dot-prevent-room-grandfather". We validate loosely: lowercase
 * alphanumerics in hyphen-separated segments, at least 8 chars, and at
 * least one hyphen (so single route words like "recover" never match).
 */
const KEY_RE = /^[a-z0-9]+(-[a-z0-9]+)+$/i

export function isValidKey(key: string | undefined | null): boolean {
  if (!key) return false
  return key.length >= 8 && KEY_RE.test(key)
}

/** Generate a fresh 4-word user key. */
export function generateKey(): string {
  return (generate(4) as string[]).join('-')
}
